import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38a4c6a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mask" }
const _hoisted_2 = { class: "dialog-main" }
const _hoisted_3 = { class: "main-title" }
const _hoisted_4 = { class: "sub-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "splice-line" }, null, -1))
const _hoisted_6 = { class: "footer" }

import { ref, computed, onMounted, onBeforeMount } from "vue";
import { queryExampaperList } from '@/api/index'

export default /*#__PURE__*/_defineComponent({
  __name: 'Dialog',
  props: {
    // 试卷列表
    mainTitle: {
        type: String,
        default: () => '',
    },
    subTitle:{
        type:String,
        default: () => ''
    },
    leftBtnText:{
        type:String,
        default: () => '取消',
    },
    rightBtnText:{
        type:String,
        default: () => '确认',
    }
},
  emits: ['cancelHandler', 'confirmHandler'],
  setup(__props, { emit: $emit }) {

const props = __props;




const cancelHandler = () => {
    console.log('cancelHandler')
    // curSelect.value = data.value
    $emit('cancelHandler')
}

const confirmHandler = () => {
    console.log('confirmHandler')
    // curSelect.value = data.value
    $emit('confirmHandler')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.mainTitle), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.subTitle), 1),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "cancel-btn",
          onClick: cancelHandler
        }, _toDisplayString(__props.leftBtnText), 1),
        _createElementVNode("div", {
          class: "confirm-btn",
          onClick: confirmHandler
        }, _toDisplayString(__props.rightBtnText), 1)
      ])
    ])
  ]))
}
}

})